export const appendFormTypeParameter = (
  url: string | undefined,
  type: 'look_up_username' | 'reset_password',
): string => {
  if (!url) return '';
  const [path, query] = url.split('?');
  const params = new URLSearchParams(query);
  params.set('type', type);
  return `${path}?${params.toString()}`;
};
